interface MenuLateralOption {
	label: string;
	imgSrc: string;
	value: 'alwaysOpen' | 'alwaysClosed' | 'hoverOpen' | 'hamburgerOpen';
}

export const MenuLateralOptions: MenuLateralOption[] = [
	{
		label: 'lbl_sempre_aberto',
		imgSrc: 'assets/images/menu-lateral-options/alwaysOpen.svg',
		value: 'alwaysOpen',
	},
	{
		label: 'lbl_sempre_fechado',
		imgSrc: 'assets/images/menu-lateral-options/alwaysClosed.svg',
		value: 'alwaysClosed',
	},
	{
		label: 'lbl_abrir_com_mouse',
		imgSrc: 'assets/images/menu-lateral-options/hoverOpen.svg',
		value: 'hoverOpen',
	},
	{
		label: 'lbl_menu_hamburguer',
		imgSrc: 'assets/images/menu-lateral-options/hamburgerOpen.svg',
		value: 'hamburgerOpen',
	},
];
